import { api } from "./api";

import { User } from "../models/user.types";

export type TLogin = { password: string; email: string };

export const login = async (login: TLogin): Promise<User> => api.post(`/login`, login).then((res) => res.data.result.user);

export const getUser = async (): Promise<User> => api.get(`/me`).then((res) => res.data.result);
